import { render, staticRenderFns } from "./notic.vue?vue&type=template&id=165953ba&scoped=true"
import script from "./notic.vue?vue&type=script&lang=js"
export * from "./notic.vue?vue&type=script&lang=js"
import style0 from "./notic.vue?vue&type=style&index=0&id=165953ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165953ba",
  null
  
)

export default component.exports